export default __webpack_public_path__ + "static/media/img_other13.ebe4a494.webp";